<template>

    <modal class="flyerline-modal" :name="name"  v-bind="$attrs" :resizable="false" width="100%" height="auto" :max-width="1024" :adaptive="true" :scrollable="true"
           @closed="$emit('closed')" @before-open="beforeOpen" @before-close="beforeClose"
           ref="modal"
    >
            <div class="modal-close">
                <a href="javascript:;" @click="$modal.hide(name)" class="fancy-close-flyerline d-flex align-items-center  text-decoration-none text-white" title="">
                    <small class="text-white mr-2 font-weight-bold">{{'txtClose'|translate}}</small>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="svg-icon">
                        <circle cx="18" cy="18" r="18" fill="#fff"/>
                        <path d="M24.92 23.33L19.59 18l5.32-5.32c.44-.44.44-1.15 0-1.59-.44-.44-1.15-.44-1.59 0L18 16.41l-5.32-5.32c-.44-.44-1.15-.44-1.59 0-.44.44-.44 1.15 0 1.59L16.41 18l-5.32 5.32c-.44.44-.44 1.15 0 1.59.44.44 1.15.44 1.59 0L18 19.59l5.33 5.33c.44.44 1.15.44 1.59 0s.44-1.15 0-1.59z" fill="#3a3a39"/>
                    </svg>
                </a>
            </div>
        <slot/>
    </modal>
</template>

<script>
    export default {
        name: "FlyerlineModal",
        props: ['name'],
        methods: {
            open(params) {
                this.$refs.modal.open(params)
            },
            close(params) {
                this.$refs.modal.close(params)
            },
            beforeOpen() {
                //Todo: check if modal in modal mmd
                //console.log('Opening...')
                var headerDesktop = document.querySelector(".sticky-container");
                if (headerDesktop) {
                    headerDesktop.classList.add("sticky-container--top");
                }
            },
            beforeClose() {
                //Todo: check if modal in modal mmd
                //console.log('Closening...')
                var headerDesktop = document.querySelector(".sticky-container");
                if (headerDesktop) {
                    headerDesktop.classList.remove("sticky-container--top");
                }
            }
        }
    }
</script>
<style lang="scss">
    .vm--container.scrollable .vm--modal {
        margin-bottom: 10px !important;
    }

    .flyerline-modal {
        background-color: rgba(30, 30, 30, 0.9);
        padding: 0.625em;

        .modal-close {
            position: relative;
            top: -2px;
            right: 0;
            padding: 20px 0;
        }

        .vm--overlay {
            /*  Bug if v-modal to high?  
            background: #1e1e1e;
            opacity: 0.9; */
            background: transparent;
        }

        .vm--modal {
            background-color: transparent;
            width: 100% !important; // wichtig!
            max-width: 64rem !important;
            padding: 0;
            overflow: visible;
            border-radius: 0;
            box-shadow: none;

            > div:not(.modal-close):not(.flyerline-modal) {
                padding: 0.625em;
                background-color:#ffffff;
            
                @media print, screen and (min-width: 64rem){
                    padding:1.25em;
                }
            }
        }

        &--small {
            .vm--modal {
                left: 0 !important;
                right: 0 !important;
                margin-left: auto !important;
                margin-right: auto !important;
                max-width: 64rem / 4 * 2.5 !important;
            }
        }
    }
</style>

